/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Import_Select_Target_File_LabelInputs */



/**
* | output |
* | --- |
* | "Select Target Subtitle File" |
*
* @param {Translation_Import_Select_Target_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_select_target_file_label = /** @type {((inputs?: Translation_Import_Select_Target_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Select_Target_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner le fichier de sous-titres cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziel-Untertiteldatei auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il file dei sottotitoli di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите целевой файл субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el archivo de subtítulos de destino.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择目标字幕文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対象の字幕ファイルを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य उपशीर्षक फ़ाइल का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o arquivo de legenda desejado")
	return /** @type {LocalizedString} */ ("Select Target Subtitle File")
});